import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapItem, UpdateTrophy } from 'app/shared/models/Progression/progression';
import { ProgressionService } from 'app/shared/services/progression/progression.service';
import { Observable, Observer } from 'rxjs';

const reader = new FileReader();

export interface DialogData {
  tophies: MapItem[];
}


@Component({
  selector: 'app-opendialog-update-background',
  templateUrl: './opendialog-update-background.component.html',
  styleUrls: ['./opendialog-update-background.component.scss']
})
export class OpendialogUpdateBackgroundComponent implements OnInit {
  updateBackgroundForm: FormGroup;
  imageBase64: string | ArrayBuffer;

  constructor(
    private progressionService: ProgressionService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<OpendialogUpdateBackgroundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData

  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    this.dialogRef.close();

  }

  convertFile(event, input): void {

    switch (typeof event) {
      case 'object':
        const file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = (res) => {
          this.imageBase64 = res.target.result;
          this.updateBackgroundForm.get(`${input}`).setValue('');
        };
        break;
      case 'string':
        this.getBase64ImageFromURL(event).subscribe(res => {
          this.imageBase64 = 'data:image/png;base64,' + res;
        });
        this.updateBackgroundForm.get(`${input}`).setValue('');
        break;

      default:
        break;
    }
  }

  private getBase64ImageFromURL(url: string) {
    return new Observable((observer: Observer<string>) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  private getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  private initForm(): void {
    this.updateBackgroundForm = this.formBuilder.group({
      imgFile: [''],
      imgLink: ['']
    });
  }

}
